import Axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import RepositoryFactory from "@/repository/factory";
const mastTokenApps = RepositoryFactory.get("mastTokenApps");

export default {
    state: {
        currentUser: localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null,
        loginError: null,
        processing: false,
        forgotMailSuccess: null,
        resetPasswordSuccess: null
    },
    getters: {
        currentUser: state => state.currentUser,
        processing: state => state.processing,
        loginError: state => state.loginError,
        forgotMailSuccess: state => state.forgotMailSuccess,
        resetPasswordSuccess: state => state.resetPasswordSuccess,
    },
    mutations: {
        setUser(state, payload) {
            state.currentUser = payload
            state.processing = false
            state.loginError = null
        },
        setLogout(state) {
            state.currentUser = null
            state.processing = false
            state.loginError = null
        },
        setProcessing(state, payload) {
            state.processing = payload
            state.loginError = null
        },
        setError(state, payload) {
            state.loginError = payload
            state.currentUser = null
            state.processing = false
        },
        setForgotMailSuccess(state) {
            state.loginError = null
            state.currentUser = null
            state.processing = false
            state.forgotMailSuccess = true
        },
        setResetPasswordSuccess(state) {
            state.loginError = null
            state.currentUser = null
            state.processing = false
            state.resetPasswordSuccess = true
        },
        clearError(state) {
            state.loginError = null
        }
    },
    actions: {
        login({ commit }, payload) {
            commit('clearError')
            commit('setProcessing', true)
            let data = payload.status ? payload.data : null
            if (typeof data == "object") {
                if (data) {
                    if (data.length >= 0) {
                        let user = data[0]
                        localStorage.setItem('token', user.Token)
                        localStorage.setItem('tokenRefresh', user.RefreshToken ? user.RefreshToken : user.Refreshtoken)
                        localStorage.setItem('user', JSON.stringify(user))
                        localStorage.setItem('license', 'namlong_2021')
                        commit('setUser', user)
                    } else {
                        let user = data
                        localStorage.setItem('token', user.Token)
                        localStorage.setItem('tokenRefresh', user.RefreshToken ? user.RefreshToken : user.Refreshtoken)
                        localStorage.setItem('user', JSON.stringify(user))
                        localStorage.setItem('license', 'namlong_2021')
                        commit('setUser', user)
                    }
                } else {
                    commit('setError', payload.message)
                    setTimeout(() => {
                        commit('clearError')
                    }, 3000)
                }
            }
        },

        register({ commit }, payload) {
            commit('clearError')
            let data = payload.status ? payload.data : null
            if (typeof data == "object") {
                commit('setError', payload.message)
                setTimeout(() => {
                    commit('clearError')
                }, 3000)

            }
        },

        forgotPassword({ commit }, payload) {
            commit('clearError')
            commit('setProcessing', true)
            firebase
                .auth()
                .sendPasswordResetEmail(payload.email)
                .then(
                    user => {
                        commit('clearError')
                        commit('setForgotMailSuccess')
                    },
                    err => {
                        commit('setError', err.message)
                        setTimeout(() => {
                            commit('clearError')
                        }, 3000)
                    }
                )
        },
        resetPassword({ commit }, payload) {
            commit('clearError')
            commit('setProcessing', true)
            firebase
                .auth()
                .confirmPasswordReset(payload.resetPasswordCode, payload.newPassword)
                .then(
                    user => {
                        commit('clearError')
                        commit('setResetPasswordSuccess')
                    },
                    err => {
                        commit('setError', err.message)
                        setTimeout(() => {
                            commit('clearError')
                        }, 3000)
                    }
                )
        },



        /*
           return await auth.(resetPasswordCode, newPassword)
            .then(user => user)
            .catch(error => error);
        */
        async signOut({ commit }) {
            if (localStorage.getItem('tokenFirebase')) {
                const response = await mastTokenApps.Delete({ token: localStorage.getItem('tokenFirebase') })
                if (response.status) {
                    localStorage.removeItem('tokenFirebase')
                }

            }
            localStorage.removeItem('token')
            localStorage.removeItem('tokenRefresh')
            localStorage.removeItem('user')
            localStorage.removeItem('license')
            commit('setLogout')
        }
    }
}
